<div class="dialog">
  <div class="dialog__title" mat-dialog-title>
    <div class="dialog__header">
      <h2>Bulk Accept/Reject ({{ data.productCount }}) Products</h2>
    </div>
    <mat-icon class="dialog__close" role="button" aria-label="Close" mat-dialog-close>close</mat-icon>
  </div>

  <div class="dialog__content" mat-dialog-content>
    <section class="dialog__section">
      <div class="section_body">Please either accept or reject the selected products.</div>
    </section>

    <app-compliance-questionnaire-comments
      (commentChanged)="changeComment($event)"
      [showSendOption]="false"
    ></app-compliance-questionnaire-comments>
  </div>
  <div class="dialog__actions" mat-dialog-actions align="end">
    <mds-button type="secondary" (click)="onStatusUpdate('Reject')">Reject</mds-button>
    <mds-button class="actions__save ml-20" type="primary" (click)="onStatusUpdate('Approve')">Approve</mds-button>
  </div>
</div>
